<template>
    <div>
        <v-server-table :name="tableName" :ref="tableName" url="/employees/disciplinary-actions/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div v-if="allowFilterSaving" class="float-left mr-1">
                    <user-filters ref="discActionSavedFilters" assetType="DisciplinaryAction" :filterKey="filterKey" @saving="setUserFilterData" @show="setUserFilterData"></user-filters>
                </div>

                <div class="float-left">
                    <table-filters-2 ref="discActionTableFilters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" filterUrl="/employees/filters/disciplinary" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['disciplinary_actions.disc_violation_id']" :btnLabel="(values) => ('Violation Types ('+values.length+')')" :selectOptions="slotProps.filterData.violationTypes" :options="{multi: true}"></multi-select>
                            </div>
                            <div class="d-inline-block">
                                <date-range-selector buttonTitle="Disciplinary Action Date" v-model="slotProps.filters['disciplinary_actions.disc_action_date']" />
                            </div>
                            <div class="d-inline-block" style="width: 300px;" v-if="!employee_id">
                                <employee-select :forFilters="true" :selectedValues="slotProps.filters['disciplinary_actions.employee_id']" v-on:vselected="((data) => { slotProps.filters['disciplinary_actions.employee_id'] = data || {};  })"></employee-select>
                            </div>
                        </template>
                    </table-filters-2>
                </div>

                <button type="button" class="btn btn-outline-success ml-2" @click="exportDataTable()" :disabled="exportingTable">
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </button>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <router-link slot="disc_action_id" slot-scope="props" :to="`/employees/disciplinary-actions/view/${props.row.disc_action_id}`" class="btn btn-sm btn-secondary" title="View Disciplinary Action">
                View - {{ props.row.disc_action_id }}
            </router-link>

            <router-link slot="violation_name" slot-scope="props" :to="`/employees/disciplinary-actions/view/${props.row.disc_action_id}`" title="View Disciplinary Action">
                <template v-if="props.row.disc_violation_id">
                    {{ props.row.violation_name }}
                </template>
                <template v-else>
                    {{ props.row.other_violation_name }}
                </template>
            </router-link>

            <template slot="penalty_name" slot-scope="props">
                <template v-if="props.row.disc_violation_id">
                    {{ props.row.penalty_name }}
                </template>
                <template v-else>
                    {{ props.row.other_penalty_name }}
                </template>
            </template>

            <template slot="bonus_disqual_time" slot-scope="props">
                <template v-if="props.row.disc_violation_id">
                    {{ props.row.bonus_disqual_time }}
                </template>
                <template v-else>
                    {{ props.row.other_bonus_disqual_time }}
                </template>
            </template>

            <router-link slot="employee_last_name" slot-scope="props" :to="`/employees/view/${props.row.employee_id}`" title="View Employee">
                {{ props.row.employee_first_name }} {{ props.row.employee_last_name }}
            </router-link>

            <template slot="supervisor_last_name" slot-scope="props">
                <user-name :user="supervisor(props.row)" />
            </template>

            <template slot="disc_action_date" slot-scope="props">
                {{ props.row.disc_action_date | moment("MM/DD/YYYY") }}
            </template>

            <template slot="JobsiteName" slot-scope="props">
                {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
            </template>

            <template slot="email_ack_at" slot-scope="props">
                <span v-if="props.row.email_ack_at">{{ props.row.email_ack_at | moment("MM/DD/YYYY") }}</span>
            </template>

            <template slot="child_row" slot-scope="props">
                <span class="font-weight-bold">Violation Detail</span><br>
                <div v-html="props.row.violation_detail"></div>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        props: {
            employee_id: {
                type: Number,
                default: null,
            },

            allowFilterSaving: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                tableName: "disciplinaryTable",
                exportingTable: false,
                columns: [
                    'disc_action_id',
                    'violation_name',
                    'penalty_name',
                    'bonus_disqual_time',
                    'supervisor_last_name',
                    'employee_last_name',
                    'disc_action_date',
                    'JobsiteName',
                    'email_ack_at',
                    'days_suspension',
                ],

                filterKey: 'discActionFilters',

                filterDefs: {
                    'disciplinary_actions.disc_violation_id': [],
                    'disciplinary_actions.disc_action_date' : '',
                    'disciplinary_actions.employee_id': {},
                }
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            options(){
                return {
                    headings: {
                        disc_action_id: 'ID',
                        violation_name: 'Violation',
                        penalty_name: 'Penalty',
                        bonus_disqual_time: 'Bonus Disqual.',
                        supervisor_last_name: 'Supervisor',
                        employee_last_name: 'Employee',
                        disc_action_date: 'Date',
                        JobsiteName: 'Jobsite',
                        email_ack_at: 'Acknowledgement',
                        days_suspension: 'Suspension (Days)',
                    },
                    saveState: this.allowFilterSaving,
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: (this.allowFilterSaving ? this.$root.getVisibleColumnsFromState(this.tableName) : false),
                    orderBy: {
                        ascending: true,
                        column: 'disciplinary_actions.disc_action_id',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('disciplinaryListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //INclude the asset
                        if(this.employee_id)
                        {
                            data.employee_id = this.employee_id;
                        }

                        //Send it
                        return data;
                    },
                    uniqueKey: 'disc_action_id',
                };
            },
        },

        methods: {
            supervisor: function(row) {
                return {
                    FirstName: row.supervisor_first_name,
                    LastName: row.supervisor_last_name,
                    deleted_at: row.supervisor_deleted_at,
                };
            },

            exportDataTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    filters: filterExtractor.extractFilters(this.filters),
                    query: (this.$refs.disciplinaryTable.getRequestParams()).query,
                    orderBy: this.$refs.disciplinaryTable.options.orderBy.column,
                    ascending: this.$refs.disciplinaryTable.options.orderBy.ascending,
                    table: this.tableName,
                    columns: this.$refs.disciplinaryTable.columns,
                    visible_columns: this.$root.getVisibleColumnsFromState(this.tableName),
                    export: true,
                    employee_id: this.employee_id,
                };

                //Send it
                this.$http.get('/employees/disciplinary-actions/list', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert
                        this.$toastr.error(err.response.data, 'Failed to Export Disciplinary Actions');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.disciplinaryTable.setPage(1);
                this.$refs.disciplinaryTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.discActionTableFilters.resetColVis(this.$refs.disciplinaryTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.discActionSavedFilters.setFilterParams(this.$refs.disciplinaryTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.discActionTableFilters.setColVis(this.$refs.disciplinaryTable);
            },
        },

        mounted(){
            //Check for a saved filter
            this.checkForAppliedFilter();
        }
    }
</script>
